import React from 'react';

import { Main, MainHeader, Body } from 'components/Main';
import { Panel, PanelTop, PanelBody } from 'components/Panel';

const NotFoundPage = ({ url }) => (
    <Main>
        <MainHeader />
        <Body id="not-found-page">
            <Panel border nopad>
                <PanelTop title="Not Found" />
                <PanelBody>
                    <p>The page {url} cannot be found</p>
                    <p>
                        You are browsing the beta version of Chorleywood Cricket Club&#39;s website, not all pages have been implemented
                        yet.
                    </p>
                </PanelBody>
            </Panel>
        </Body>
    </Main>
);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/views/not-found/NotFoundPage.jsx